import { observable } from 'mobx'

class QueueStore {
  @observable
  /** 是否在排队中    in: 正在排队中   stop: 没有排队   success: 排队成功 */
  queueStatus: 'in' | 'stop' | 'success' = 'stop'
  @observable
  /** 子任务状态 */
  subTaskStatus: 'none' | 'success' = 'none'
  @observable
  currentQueueInfo: GameQueuePayload | null = null
}

export default new QueueStore()
